import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Subscription} from 'rxjs';

import {GtmService} from 'src/app/services/gtm.service';
import {BookingState} from '../../types/booking-state';
import {ToolsService} from '../../../../services/tools.service';
import {BookingServiceDetail} from '../../../../types/BookingServiceDetail';
import {BookingV2ManagerService} from '../../services/booking-v2-manager.service';
import {BookingV2StateService} from '../../services/booking-v2-state.service';
import {BookingV2DataService} from '../../services/booking-v2-data.service';
import {BookingProviderDetailsLinkWithTreatments} from '../../types/booking-provider-details-link-with-treatments';

@Component({
  selector: 'app-service-section-v2',
  templateUrl: './service-section-v2.component.html',
  styleUrls: ['./service-section-v2.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ServiceSectionV2Component implements OnInit, OnDestroy {
  public servicesListGrouped: BookingProviderDetailsLinkWithTreatments[];
  public selectedBookingServiceId: string;
  private subscriptions: Subscription[] = [];

  constructor(
    private tools: ToolsService,
    private bookingManager: BookingV2ManagerService,
    private bookingState: BookingV2StateService,
    private bookingData: BookingV2DataService,
    private gtmService: GtmService
  ) {}

  ngOnInit(): void {
    this.setListeners();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  public onClickService(service: BookingServiceDetail, group: number): void {
    this.bookingManager.selectService(service, group);
  }

  public isSelected(service: BookingServiceDetail): boolean {
    return service.id === this.selectedBookingServiceId;
  }

  public getNotePart1(note: string): string {
    return note.split(' ').slice(0, 7).join(' ');
  }

  public getNotePart2(note: string): string {
    return ' ' + note.split(' ').slice(7, 999).join(' ');
  }

  public showReadMore(note: string): boolean {
    return note && this.getNotePart2(note).trim().length > 0;
  }

  public trackByService(i: number, el: BookingServiceDetail) {
    return el ? el.id : null;
  }

  public trackByGroup(i: number, el: BookingProviderDetailsLinkWithTreatments) {
    return el ? el.careServiceId : null;
  }

  public openTreatmentDetailsModal(
    service: BookingServiceDetail,
    group: number
  ): void {
    this.bookingManager.openTreatmentDetailsModal(service, group);
  }

  public getItemDetailsCssClass(item: BookingServiceDetail): string {
    return (item.price == null || item.price === '') &&
      (item.activityLength == null || item.activityLength === '') &&
      item.seoInformation &&
      item.seoInformation !== ''
      ? 'empty-details'
      : '';
  }

  private setListeners(): void {
    this.subscriptions.push(
      this.bookingState.state$.subscribe((result) =>
        this.processBookingState(result)
      ),
      this.bookingData.servicesGrouped$.subscribe(
        (result) => (this.servicesListGrouped = result)
      )
    );
  }

  private processBookingState(state: BookingState): void {
    this.selectedBookingServiceId = state.selectedBookingServiceId;
  }
}
